import { InfoCardGrid } from '@rsa-digital/evo-shared-components/components/InfoCard';
import {
  Heading,
  StyledCardGrid,
} from '@rsa-digital/evo-shared-components/components/InfoCard/InfoCardGrid/styles';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledInfoCardGrid = styled(InfoCardGrid)`
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};
  margin-bottom: 0;

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}

  ${Heading} {
    margin-top: 0;
  }

  ${StyledCardGrid} {
    margin-top: ${spacing(2)};
  }
`;
